import React from 'react'
import moment from 'moment'
import ChatHeader from './ChatHeader'
import BotMessage from './BotMessage'
import { extractDocumentsFromText } from '../../utils/common'
import { BOT_USER_NAME, BOT_USER_ID } from '../../utils/constant'
import { getUserAvatar, hasAvatarImage } from '../../utils/avatarUtils'
import './styles/ChannelMessages.css'

function PinnedMessages({ messages = [], onClose, userAvatars = [] }) {

  return (
    <div className="thread-list-window">
      <ChatHeader
        title="Pinned Messages"
        onBack={onClose}
      />
      <div className="thread-list-content">
        {messages.length === 0 ? (
          <div className="message-container">
            <span className="message-sender">No pinned messages.</span>
          </div>
        ) : (
          messages.map(msg => {
            let text = msg.msg
            const { documents, text: cleanedText } = extractDocumentsFromText(text)
            const isNewFormat = cleanedText !== text
            text = cleanedText

            if (documents.length === 0 && msg.mentions) {
              msg.mentions.forEach((mention) => {
                text = text.replaceAll(
                  `@${mention.username}`,
                  `<span class='mention'>@${mention.name}</span>`
                )
              })
            }

            let sender = msg.u?.name || 'Unknown'
            if (msg.u?.username === BOT_USER_ID) {
              sender = BOT_USER_NAME
            }

            return (
              <div key={msg._id} className="message-container">
                <div className="message-header">
                  <div className="message-avatar">
                    {hasAvatarImage(msg.u?.username, userAvatars) ? (
                      <img
                        src={getUserAvatar(msg.u?.username, userAvatars)}
                        alt={msg.u?.username || 'User'}
                        className="avatar-image"
                        onError={(e) => {
                          e.target.style.display = 'none'
                          e.target.nextSibling.style.display = 'flex'
                        }}
                      />
                    ) : null}
                    <div className={`avatar-fallback ${hasAvatarImage(msg.u?.username, userAvatars) ? 'hidden' : ''}`}>
                      {getUserAvatar(msg.u?.username, userAvatars)}
                    </div>
                  </div>
                  <div className="message-header-content">
                    <span className="message-sender">
                      {sender}
                    </span>
                    <span className="message-timestamp">
                      {moment(msg.ts).format('MMM DD, YYYY h:mm A')}
                    </span>
                  </div>
                </div>
                <div className="message-box">
                  {documents.length > 0 ? (
                    <BotMessage documents={documents} explanation={isNewFormat ? text : undefined} />
                  ) : (
                    <div
                      className="message-content"
                      dangerouslySetInnerHTML={{ __html: text }}
                    />
                  )}
                </div>
              </div>
            )
          })
        )}
      </div>
    </div>
  )
}

export default PinnedMessages
